import Bowser from "../frameworks/bowser/bowser.js";
import * as Utils from "./utils";

class UserPrefs {
    constructor() {
        this.setupDefaults();
    }

    setupDefaults() {
        this.model = JSON.parse(this.readCookie("UserPreferencesCookie"));
        this.menu = "menuSlider";

        if (this.model) {
            //if (this.model.universal.menuDisplayOption === "News") {
            //    this.menu = "menuSlider";
            //} else {
            //    this.menu = "menuOverlay";
            //}
            this.setPrefs();
        }
        this.request = this.PreferencesPostModel();
        this.avatar = "";
        /*    this.colorButton = document.getElementById("primary_color");*/
        ///* Set zoom level */
        //if (this.model.home.iconZoomLevel != null) {
        //   this.zoomIcons(this.model.home.iconZoomLevel);
        //}    
    }

    onReadyEvents() {
        var self = this;

        $(".tools-switch input").on("change", self.toolsSwitchOnChange.bind(this));

        $(".tools-switch input").on("change", self.toolsSwitchOnChange.bind(this));

        //$(".dark-mode-switch input").on(
        //  "change",
        //  this.darkModeSwitchOnChange.bind(this)
        //);

        //$(".open-menu-switch input").on(
        //  "change",
        //  self.openMenuSwitchOnChange.bind(this)
        //  );

        //self.colorButton.addEventListener("change", () => {
        //  this.setColor(colorButton.value);
        //});

        //self.colorButton.addEventListener("input", (e) => {
        //  this.setColor(e.target.value);
        //});

        document.documentElement.style.setProperty(
            "--background-primary-accent-color", '#092b5a');

        document.documentElement.style.setProperty(
            "--button-accent-color", '#a50c0c');

        //$("input[name='menu-setup']").change(function () {
        //  self.menu = $(this).val();
        //  self.hideNavAction();
        //  if (self.menu == "menuSlider") {
        //    $("#open-menu-checkbox").prop("disabled", false);
        //    self.setMenu("News");
        //  } else {
        //    $("#open-menu-checkbox").prop("disabled", true);
        //    self.setMenu("Expanded");
        //  }
        //});

        $("#btnSubmit").on("click", self.submitButtonOnClick.bind(this));

        var file = document.querySelector('#ImageFile');
        file.addEventListener('change', (e) => {
            // Get the selected file
            var [file] = e.target.files;
            // Get the file name and size
            var { name: fileName, size } = file;
            // Convert size in bytes to kilo bytes
            var fileSize = (size / 1000).toFixed(2);
            // Set the text content
            var fileNameAndSize = `${fileName} - ${fileSize}KB`;
            document.querySelector('.file-name').textContent = fileNameAndSize;
        });

        $("#iconZoomSelector").on("change", self.saveZoomLevelPref.bind(this));
    }

    saveZoomLevelPref(e) {
        $(".widget-icons").addClass("race-block");
        $("#iconZoomSelector").addClass("race-block");

        //the state of this.request cannot be relied upon because of multiple instances of UserPrefs.js. to work around this, read from the cookie which will have the correct values
        this.model = JSON.parse(this.readCookie("UserPreferencesCookie"));
        this.request = this.PreferencesPostModel();

        var v = document.getElementById("iconZoomSelector").value;
        this.request.Home.IconZoomLevel = Number(v);
        this.postPrefs();
        this.zoomIcons(v);
    }


    toolsSwitchOnChange(e) {
        const isOn = e.currentTarget.checked;
        var widgetAction = false;
        if (isOn) {
            document.documentElement.style.setProperty("--widget-access", "flex");
            widgetAction = false;
        } else {
            document.documentElement.style.setProperty("--widget-access", "none");
            widgetAction = true;
        }

        //the state of this.request cannot be relied upon because of multiple instances of UserPrefs.js. to work around this, read from the cookie which will have the correct values
        this.model = JSON.parse(this.readCookie("UserPreferencesCookie"));
        this.request = this.PreferencesPostModel();

        this.request.Home.HideHomeTools = widgetAction;
        this.postPrefs();
    }

    //darkModeSwitchOnChange(e) {
    //    this.toggleDarkMode(e.currentTarget.checked);
    //}

    // TODO: REMOVE - NC-04052023 We don't need this logic anymore, let's wait for feedback and remove it completely. 
    //openMenuSwitchOnChange(e) {
    //  var darkModeAction = true;
    //  const isOn = e.currentTarget.checked;
    //  if (isOn) {
    //    $("#menu-hamburger-lg").html("close"); //change to close button
    //    $("#menu-hamburger-sm").html("close"); //change to close button
    //    if ($(window).width() < 350) {
    //      $("#closeSideNav").removeClass("d-none");
    //    }
    //    $("#sidenav").css({
    //      width: "300px",
    //      "background-image": "none",
    //      height: "calc(100% - 40px)",
    //      "margin-top": "20px",
    //    });
    //    $("#main-content").css({
    //      width: "calc(100% - 300px)",
    //      "margin-left": "300px",
    //    });
    //    $("nav").css({
    //      width: "100%",
    //      transition: "ease 0.5s",
    //    });

    //    $(".toggle-menu-item").addClass("fixed-nav");
    //    $("#closeSideNav").addClass("fixed-nav");

    //    if ($("nav").css("position") == "fixed") {
    //      $("nav").css({
    //        width: "calc(100% - 340px)",
    //        transition: "ease 0.5s",
    //      });
    //    }
    //  } else {
    //    $("#menu-hamburger-lg").html("menu_open"); //change back to hamburger
    //    $("#menu-hamburger-sm").html("menu_open"); //change back to hamburger
    //    $("#sidenav").css({
    //      width: "0",
    //    });
    //    $("#main-content").css({
    //      width: "100%",
    //      "margin-left": "0",
    //      display: "block",
    //    });
    //    $("nav").css({
    //      width: "100%",
    //      transition: "ease 0.5s",
    //    });

    //    $(".toggle-menu-item").removeClass("fixed-nav");
    //    $("#closeSideNav").removeClass("fixed-nav");

    //    if ($("nav").css("position") == "fixed") {
    //      $("nav").css({
    //        width: "calc(100% - 40px)",
    //        transition: "ease 0.5s",
    //      });
    //    }
    //  }
    //}

    submitButtonOnClick() {
        if ($("#EmailAddress").val() == "") {
            Utils.launchToast("Error: Email Address is missing on User Profile.", "warning", "red");
            $("#UpdateEmail").show();
            return false;
        }

        $("#UpdateEmail").hide();

        var helpBaseUrl =
            window.location.protocol + "//" + window.location.host + "/AlliedPilots";

        //detect if its a mobile device
        var source = "Desktop/Other";
        var standalone = window.navigator.standalone,
            userAgent = window.navigator.userAgent.toLowerCase(),
            safari = /safari/.test(userAgent),
            ios = /iphone|ipod|ipad/.test(userAgent);

        if (ios) {
            if (!standalone && safari) {
                // Safari
            } else if (!standalone && !safari) {
                // iOS webview
                source = 'iOS Mobile';
            };
        } else {
            if (userAgent.includes('wv')) {
                // Android webview
                source = 'Android Mobile';
            } else {
                // Chrome
            }
        };

        var result = Bowser.getParser(window.navigator.userAgent);

        var browserData = (''
            + 'Browser Name: ' + result.parsedResult.browser.name + ','
            + 'Browser Version:  ' + result.parsedResult.browser.version + ','
            + 'Browser Engine: ' + result.parsedResult.engine.name + ','
            + 'Operating System: ' + result.parsedResult.os.name + ','
            + 'Operating System Version: ' + result.parsedResult.os.version + ','
            + 'Operating System Version Name: ' + result.parsedResult.os.versionName + ','
            + 'Source: ' + source + ','
        );

        var form = $("#sendEmail")[0];
        var formData = new FormData(form);

        var files = $("#ImageFile").get(0).files;
        if (files.length > 0) {
            formData.append("ImageFile", files[0]);
        }
        formData.append("BrowserData", browserData);
        formData.append("BrowserUrl", $(location).attr('href'));

        $.ajax({
            type: "POST",
            url: helpBaseUrl + "/Component/SendEmail",
            data: formData,
            processData: false,
            contentType: false,
            dataType: "json",
            async: false,
            success: function (response) {
                alert(response.message);
                document.location.href = "/MemberHome";
            },
            error: function (response) {
                alert(response.message);
                document.location.href = "/";
            },
        });
    }

    readCookie(key) {
        var result;
        return (result = new RegExp(
            "(?:^|; )" + encodeURIComponent(key) + "=([^;]*)"
        ).exec(document.cookie))
            ? result[1]
            : null;
    }

    setPrefs() {
        /* 1.2.1: Set Dark Mode */
        if (this.model.universal.darkMode) {
            if (this.model.universal.darkMode == true) {
                //$('html').addClass('darkMode');
                document.querySelector(":root").classList.add("darkMode");
            }
        }
        /* 1.2.2: Set Theme Color */
        //if (this.model.universal.themeColor != null) {
        //      document.documentElement.style.setProperty(
        //          "--background-primary-accent-color",
        //          this.model.universal.themeColor
        //      );
        //      document.documentElement.style.setProperty(
        //          "--button-accent-color",
        //          this.model.universal.themeColor
        //      );
        //}
        /* 1.2.3: Set Home Image */
        if (this.model.home.homeImageId) {
            var url =
                "url(/-/media/AlliedPilots/BackgroundBanners/" +
                this.model.home.homeImageId +
                ".jpg)";
            document.documentElement.style.setProperty("--background-image", url);
        }
        /* 1.2.4: Set Hide tools */
        if (this.model.home.hideHomeTools != null) {
            if (this.model.home.hideHomeTools == false) {
                document.documentElement.style.setProperty("--widget-access", "flex");
            } else {
                document.documentElement.style.setProperty("--widget-access", "none");
            }
        }
        /* 1.2.5: Set Notifications */
        if (this.model.notifications.receiveNotifications != null) {
            //insert notification prefs
        }
        /* 1.2.6: Set User Avatar */
        if (this.model.universal.avatar != null) {
            var url =
                "/-/media/AlliedPilots/Member/Avatars/" +
                this.model.universal.avatar +
                ".png";
            this.avatar = url;
        }

    }

    openSettingTab(evt, tabName) {
        var i, tabcontent, tablinks;
        tabcontent = document.getElementsByClassName("settingscontent");
        for (i = 0; i < tabcontent.length; i++) {
            tabcontent[i].style.display = "none";
        }
        tablinks = document.getElementsByClassName("settingslinks");
        for (i = 0; i < tablinks.length; i++) {
            tablinks[i].className = tablinks[i].className.replace(" active", "");
        }
        document.getElementById(tabName).style.display = "block";
        evt.currentTarget.className += " active";
    }

    //setColor(color) {
    //  document.documentElement.style.setProperty(
    //    "--background-primary-accent-color",
    //    color
    //  );
    //   document.documentElement.style.setProperty("--button-accent-color", color);
    //  //document.getElementById("primary_color").value = color;
    //  this.request.Universal.ThemeColor = color;
    //  this.postPrefs();
    //}

    setMenu(option) {
        this.request.Universal.MenuDisplayOption = option;
        this.postPrefs();
    }

    //setBg(imageUrl, imageName) {
    //    var url = "URL(" + imageUrl + ")";
    //    document.documentElement.style.setProperty("--background-image", url);
    //    this.request.Home.HomeImageId = imageName;
    //    this.postPrefs();
    //}

    toggleDarkMode(isDarkMode) {
        var darkModeAction = true;
        if (isDarkMode) {
            $("html").addClass("darkMode");
            $("#lightmodeicon").addClass("d-flex");
            $("#darkmodeicon").removeClass("d-flex");
            darkModeAction = true;
            if (typeof activateTheme === 'function') {
                activateTheme("dark");
            }
        } else {
            $("html").removeClass("darkMode");
            $("#darkmodeicon").addClass("d-flex");
            $("#lightmodeicon").removeClass("d-flex");
            darkModeAction = false;
            if (typeof activateTheme === 'function') {
                activateTheme("light");
            }
        }

        this.request.Universal.DarkMode = darkModeAction;
        this.postPrefs();
    }

    setAvatar(avatar, avatarID) {
        document.getElementById("avatar").src = avatar;
        document.getElementById("avatar-profile").src = avatar;
        this.request.Universal.Avatar = avatarID;
        this.postPrefs();
    }

    setupBookmark(bookmarks) {
        //var toolsWindow = "bookmarks";
        var validBookmarks = bookmarks.filter((bookmarkId) => document.getElementById(bookmarkId) != null);
        if (validBookmarks.length != bookmarks.length) {
            this.model.home.bookmarkedToolsIds = validBookmarks;
            this.request.Home.BookmarkedToolsIds = validBookmarks;
            this.postPrefs();
        }

        for (var i = 0; i < validBookmarks.length; i++) {
            var element = document.getElementById(validBookmarks[i]);
            var item = element.getAttribute('onclick');
            eval(item);
        }
    }

    saveToBookmark(_this, widget, iconImage, id, link, openNewTab, abbrv, description) {
        $(".widget-icons").addClass("race-block");
        $("#iconZoomSelector").addClass("race-block");
        var self = this;
         
        var storeTool = "#" + id;
        if ($(storeTool).hasClass("deactivate")) {
            this.removeTool(id);
            var icon = "#Tool-" + id;
            $(icon).remove();
            $(icon).remove();
            $(_this).removeClass("deactivate");
        } else {
            var template = document.querySelector("#favorite-widgets");
            if (template) {
                var clone = template.content.cloneNode(true);
                var item = clone.querySelectorAll("li");
                item[0].id = "Tool-" + id;
                item[0].title = description || item[0].id;

                var icon = clone.querySelectorAll("div");
                icon[0].onmousedown = function () {
                    Utils.startPressTimer();
                };
                icon[0].onmouseup = function () {
                    Utils.endPressTimer(link, openNewTab.toLowerCase());
                };

                var image = clone.querySelectorAll(".img-light-mode");
                var abv = clone.querySelectorAll("h7");

                if (iconImage) {
                    image[0].src = iconImage.replace('dark', 'light');
                } else {
                    if (abv[0]) {
                        abv[0].innerText = abbrv;
                    } else {
                        abv.innerText = abbrv;
                    }
                }
                var image_dark = clone.querySelectorAll(".img-dark-mode");
                if (iconImage) {
                    image_dark[0].src = iconImage.replace('light', 'dark');
                } else {
                    if (abv[0]) {
                        abv[0].innerText = abbrv;
                    } else {
                        abv.innerText = abbrv;
                    }
                }

                var title = clone.querySelectorAll("p");
                title[0].innerText = widget;

                //if (iconImage && index == 1) {
                //    title[0].style.display = "none";
                //} else if (!iconImage && index == 1) {
                //    image[0].style.display = "none";
                //}

                var span = clone.querySelectorAll("span");
                span[0].onclick = function () {
                    self.removeTool(id);
                    var icon = "#Tool-" + id;
                    $(icon).remove();
                };

                $("#widgets").find(" > li:nth-last-child(1)").before(clone)
            }

            var currentItem = "#" + id;
            $(currentItem).addClass(" deactivate");
            this.addTool(id);        
        }
    }

    clearBookmarkedToolsIds() {
        this.request.Home.BookmarkedToolsIds = [];
    }

    addToolWithoutPost(tool) {
        if (!this.request.Home.BookmarkedToolsIds) {
            this.request.Home.BookmarkedToolsIds = [];
        }
        if (
            this.searchStringInArray(tool, this.request.Home.BookmarkedToolsIds) == false
        ) {
            this.request.Home.BookmarkedToolsIds.push(tool);
            console.log(tool);
        }
    }

    addTool(tool) {
        if (!this.request.Home.BookmarkedToolsIds) {
            this.request.Home.BookmarkedToolsIds = [];
        }
        if (
            this.searchStringInArray(tool, this.request.Home.BookmarkedToolsIds) == false
        ) {
            this.request.Home.BookmarkedToolsIds.push(tool);
            this.postPrefs();
            console.log(tool);
            this.zoomIcons(this.request.Home.IconZoomLevel);
        } else {
            //in the case where the preference was turned off, then back on, we won't need to post that pref, but unlock the icons and set the zoom
            $(".widget-icons").removeClass("race-block");
            $("#iconZoomSelector").removeClass("race-block");
            console.log("Reselect:" + tool);
            this.zoomIcons(this.request.Home.IconZoomLevel);
        }
    }

    searchStringInArray(str, strArray) {
        for (var j = 0; j < strArray.length; j++) {       
            if (strArray[j] == str) {
                return true;
            }
        }
        return false;
    }

    removeToolByX(event) {
        var tool = event.target.closest('li').id.replace('Tool-', '');

        for (var i = 0; i < this.request.Home.BookmarkedToolsIds.length; i++) {
            if (this.request.Home.BookmarkedToolsIds[i] === tool) {
                this.request.Home.BookmarkedToolsIds.splice(i, 1);
                $("#" + event.target.closest('li').id).remove();
                $("#" + tool + ".deactivate").removeClass("deactivate");
            }
        }
        this.postPrefs();
    }


    removeTool(tool) {
        var icon = "#Tool-" + tool;
        for (var i = 0; i < this.request.Home.BookmarkedToolsIds.length; i++) {
            if (this.request.Home.BookmarkedToolsIds[i] === tool) {
                this.request.Home.BookmarkedToolsIds.splice(i, 1);
                $(icon).remove();
                var storeTool = "#" + tool;
                $(storeTool).removeClass("deactivate");
                //$("#add-icons").show();
            }
        }
        this.postPrefs();
    }

    //saveCommittee(committee) {
    //    var committeeArray = [];
    //    if (this.request.Preferences.HomeCommitteePage) {
    //        committeeArray = this.request.Preferences.HomeCommitteePage.split(",");
    //    }
    //    committeeArray.push(committee);
    //    this.request.Preferences.HomeCommitteePage = committeeArray.toString();
    //    this.postPrefs();
    //}

    //removeCommittee(committee) {
    //    var committeeArray = [];
    //    if (this.request.Preferences.HomeCommitteePage) {
    //        committeeArray = this.request.Preferences.HomeCommitteePage.split(",");
    //        committeeArray = committeeArray.filter((e) => e !== committee);
    //    }
    //    this.request.Preferences.HomeCommitteePage = committeeArray.toString();
    //    this.postPrefs();
    //}

    PreferencesPostModel() {
        if (this.model) {
            var userName = this.model.userName;
            var home = {
                HomeImageId: this.model.home.homeImageId,
                HideHomeTools: this.model.home.hideHomeTools,
                BookmarkedToolsIds: this.model.home.bookmarkedToolsIds,
                IconZoomLevel: this.model.home.iconZoomLevel
            };
            var universal = {
                MenuDisplayOption: this.model.universal.menuDisplayOption,
                IsMenuMinified: this.model.universal.isMenuMinified,
                IsMenuOpen: this.model.universal.isMenuOpen,
                ThemeColor: this.model.universal.themeColor,
                DarkMode: this.model.universal.darkMode,
                Avatar: this.model.universal.avatar,
            };
            var notifications = {
                ReceiveNotifications: this.model.notifications.receiveNotifications,
            };
            var preferences = {
                HomeCommitteePage: this.model.preferences.homeCommitteePage,
            };

            return {
                UserName: userName,
                Home: home,
                Universal: universal,
                Notifications: notifications,
                Preferences: preferences,
            };
        }
    }

    postPrefs(storeToDB = true) {
        $.ajax({
            url: "/AlliedPilots/PostUserPrefs/PostPrefs",
            datatype: "json",
            type: "POST",
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify({
                model: { storeToDatabase: storeToDB, dbPreferencesModel: this.request },
            }),
            async: true,
            processData: false,
            cache: false,

            success: function (Data) {
                var cusid = Data;
                $(".widget-icons").removeClass("race-block");
                $("#iconZoomSelector").removeClass("race-block");
                Utils.launchToast("Setting saved", "task_alt", "green");
            },
            error: function (xhr) {
                //  alert("error");
                $(".widget-icons").removeClass("race-block");
                $("#iconZoomSelector").removeClass("race-block");
                Utils.launchToast("Error: Setting not saved", "warning", "red");
                return null;
            },
            error: function (exception) {
                // alert('Exeption:' + exception);
                $(".widget-icons").removeClass("race-block");
                $("#iconZoomSelector").removeClass("race-block");
                Utils.launchToast("Error: Setting not saved", "error", "red");
                console.log("Ooops", "Exeption:" + exception.responseJSON, "error");
            },
        });
    }

    openDashboardTab(evt, tabName) {
        var i, tabcontent, tablinks;
        tabcontent = document.getElementsByClassName("dashboardtabcontent");
        for (i = 0; i < tabcontent.length; i++) {
            tabcontent[i].style.display = "none";
        }
        tablinks = document.getElementsByClassName("profiletablinks");
        for (i = 0; i < tablinks.length; i++) {
            tablinks[i].className = tablinks[i].className.replace(" active", "");
        }
        document.getElementById(tabName).style.display = "block";
        evt.currentTarget.className += " active";

        //document.getElementById("dashboardTabTitle").innerText = tabName;
    }

    clearSearches() {
        localStorage.clear("recent-searches");
        $(".recent-searches li").remove();
    }

    getval(sel) {
        document.getElementById("user-headline").innerText = sel.value;
    }

    getsubval(sel) {
        document.getElementById("user-subheadline").innerText = sel.value;
    }

    loadMenuView(menu) {
        this.menu = "menuSlider";

        //if (menu != "menuOverlay") {
        //  //document.getElementById("news-menu-setup").checked = true;
        //  this.menu = "menuSlider";
        //} else {
        //  //document.getElementById("expanded-menu-setup").checked = true;
        //  self.menu = "menuOverlay";
        //}
        this.loadNavAction();
    }

    loadNavAction() {
        var self = this;

        $('[data-toggle="collapse"]').on("click touchend", function () {
            var dataClassValue = $(this).attr("data-class");
            switch (true) {
                case dataClassValue === "nav-function-minify":
                    var target = $(this).attr("data-target") || "body";
                    if (
                        self.model.universal.isMenuMinified ===
                        $(target).hasClass(dataClassValue)
                    ) {
                        self.setNewsMinifiedMenu(!self.model.universal.isMenuMinified);
                    }

                    $(target).toggleClass(dataClassValue);
                    $("#main-content").toggleClass("quarterNav");
                    $("#main-content").toggleClass("qnavextended");

                    break;
                case dataClassValue === "nav-function-fixed":
                    var target = "body";
                    if (
                        self.model.universal.isMenuOpen ===
                        $(target).hasClass(dataClassValue)
                    ) {
                        self.setNewsMenuOpen(!self.model.universal.isMenuOpen);
                    }
                    $(target).toggleClass(dataClassValue);

                    break;
                default:
                    var focusTarget = $(this).attr("data-focus");
                    if (focusTarget) {
                        setTimeout(function () {
                            $("#" + focusTarget).focus();
                        }, 1000);
                    }
                    break;
            }
        });

        $("#searchbox-panel").on("show.bs.collapse", function (e) {
            setTimeout(function () {
                $("#searchbox").focus();
            }, 1000);
        });

        $("#sidenav-modal").on("show.bs.modal", function (e) {
            $("#sidenav-modal").addClass("modal");
            self.showNavAction();
        });

        $("#sidenav-modal").on("show.bs.collapse", function (e) {
            if (self.menu == "menuSlider") {
                $("#sidenav-modal").show();
                $("#sidenav-modal").removeClass("modal");
                self.showNavAction();
            } else {
                $("#sidenav-modal").modal("show");
            }
        });

        $("#sidenav-modal").on("hidden.bs.modal", function (e) {
            self.hideNavAction();
        });

        $("#sidenav-modal").on("hidden.bs.collapse", function (e) {
            self.hideNavAction();
        });
               
    }

    showNavAction() {
        if (this.menu == "menuSlider") {
            //$("#expanded-view").hide();
            $("#news-view").show();

            $("#close-flag .material-icons").html("close"); //show floating close flag
            $("#menu-hamburger-lg").html("close"); //change to close button
            $("#menu-hamburger-sm").html("close"); //change to close button
            if ($(window).width() < 350) {
                $("#closeSideNav").removeClass("d-none");
            }
            $("#sidenav").addClass("openSideMenu");
            $("#main-content").addClass("quarterNav");
        } else {
            //$("#expanded-view").show();
            $("#news-view").hide();
            $("html").css("overflow", "hidden");
        }
    }

    hideNavAction() {
        $("#sidenav-modal").removeClass("modal");
        $("#sidenav-modal").removeClass("show");
        if (this.menu == "menuSlider") {
            $("#close-flag .material-icons").html("menu_open"); //show floating close flag
            $("#menu-hamburger-lg").html("menu_open"); //change back to hamburger
            $("#menu-hamburger-sm").html("menu_open"); //change back to hamburger
        } else {
            $("html").css("overflow", "auto");
        }

        $("#sidenav").removeClass("openSideMenu");
        $("#main-content").removeClass("quarterNav");
        $("#main-content").removeClass("fullNav");
    }

    setNewsMinifiedMenu(option) {
        this.request.Universal.IsMenuMinified = option;
        this.postPrefs(false);
    }

    setNewsMenuOpen(option) {
        this.request.Universal.IsMenuOpen = option;
        this.postPrefs(false);
    }

    zoomIcons(zoomLevel) {
        //zoom icon based on zoom level user prefer
        $(".icons").css("zoom", zoomLevel);
        $("#add-icons").css("zoom", zoomLevel);
        if (navigator.userAgent.includes('Firefox')) {
            $(".icons").css("-moz-transform", 'scale(' + zoomLevel + ')');
            $("#add-icons").css("-moz-transform", 'scale(' + zoomLevel + ')');

            if (zoomLevel > 1) {
                var marginLevel = 10
                if (zoomLevel >= 1.5) {
                    marginLevel = 15
                }
                if (zoomLevel > 1.75) {
                    $("#widgets p").css("margin-top", marginLevel + 'px');
                }
                $(".icons").css("margin", marginLevel + 'px');
                $("#add-icons").css("margin", marginLevel + 'px');
            }
        }
    }
}

export default UserPrefs;
